import styled from 'styled-components';

const TextAnimationStyle = styled.div`
	.wrapper-word {
		display: inline-block;
		overflow: hidden;
		white-space: pre;

		span {
			display: inline-block;
			transform: translateY(100%);
		}
	}

	&.active {
		.wrapper-word {
			span {
				transform: translateY(0);
				transition: calc(var(--trTime)) var(--itemDelay) ease-out;
			}
		}
	}
	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default TextAnimationStyle;
